<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">

      <v-expansion-panel class="mb-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
            <v-flex sm12 md12 lg4>
              <v-autocomplete
                  v-model="filters.email"
                  :loading="loading.emails"
                  :items="emails"
                  chips clearable
                  item-text="email_id"
                  item-value="email_id"
                  :search-input.sync="search_name" solo flat
                  label="Start typing to search Email"
                  v-on:keyup.enter="getList"
              ></v-autocomplete>
            </v-flex>

            <v-flex sm12 md12 lg4>
              <v-text-field
                  solo flat
                  v-model="filters.suggestion"
                  label="Suggestion" v-on:keyup.enter="getList"></v-text-field>
            </v-flex>

            <v-flex sm12 md12 lg4 style="display: flex; justify-content: center; margin-top: -17px;">
              <v-btn @click="applyFilters" color="primary" class="mt-3">
                Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-data-table
        no-results-text="Loading... Please wait"
        :headers="headers"
        :items="suggestion_list"
        class="elevation-1"
        :pagination.sync="pagination"
        :loading="loaders.suggestion_list_loader"
        :total-items="total_items"
        :rows-per-page-items="[10, 20, 50, 100]"
      >
<!--        <template v-slot:headers="props">-->
<!--          <tr>-->
<!--            <th-->
<!--              style="width: 20%"-->
<!--              v-for="header in props.headers"-->
<!--              :key="header.text"-->
<!--            >-->
<!--              {{ header.text }}-->
<!--            </th>-->
<!--          </tr>-->
<!--        </template>-->
        <template v-slot:items="props">
          <td>
            <router-link :to="{name:'suggestionDetails',params:{id:props.item.guest_user_id}}">
              {{ props.item.first_name + " " + props.item.last_name}}
            </router-link>
          </td>
          <td>{{ props.item.email_id }}</td>
          <td>{{ props.item.criticality }}</td>
          <td style="width:30%">{{ props.item.suggestion }}</td>
          <td>{{ props.item.created_at | appDateTimeFormat}}</td>
        </template>
<!--        <template slot="no-data">-->
<!--          <v-layout-->
<!--            row-->
<!--            wrap-->
<!--            justify-center-->
<!--            class="text-xs-center"-->
<!--            v-if="loaders.suggestion_list_loader"-->
<!--          >-->
<!--            Loading... Please wait-->
<!--          </v-layout>-->
<!--          <v-layout row wrap justify-center class="text-xs-center" v-else>-->
<!--            No data available-->
<!--          </v-layout>-->
<!--        </template>-->
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "index",
  data: () => {
    return {
      headers: [
        {
          text: "User Name",
          value: "user name",
          align: "left",
          sortable: false,
        },
        {
          text: "Email-ID",
          value: "email-id",
          sortable: false,
        },
        {
          text: "Criticality",
          value: "criticality",
          sortable: false,
        },
         {
          text: "Suggestion",
          value: "suggestion",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: false,
        },
      ],
      loaders: {
        suggestion_list_loader: false,
      },
      suggestion_list: [],
      total_items: 10,
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: { sortBy: "created_at", descending: false, rowsPerPage: 10 },
      filters: {
        title: "",
        Published: false,
        Draft: false,
        email: '',
        suggestion: ''
      },
      loading: {
        email: false,
        suggestion: false
      },
      suggestions: [],
      emails: [],
      search_name: "",

    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
    search_name: function (val){
      if (val != null && val.length >= 3) {
        this.loading.email = true;
        this.getEmailList();
      }
    }
    // search_title: {
    //   handler(newVal) {
    //     if (newVal != null && newVal.length > 3) {
    //       this.getTitlesList(newVal);
    //     }
    //   },
    // },
    // "filters.title": {
    //   handler(value) {
    //     if (value == undefined) {
    //       this.filters.title = "";
    //       this.getList();
    //     }
    //   },
    // },
  },
  methods: {
    // filter(e) {
    //   this.filters.Published = false;
    //   this.filters.Draft = e;

    //   this.getList();
    // },
    // filterPublished(e) {
    //   this.filters.Draft = false;
    //   this.filters.Published = e;
    //   this.getList();
    // },
    // searchByTitle() {
    //   this.getList();
    // },
    applyFiltersOnLoad:function(){
      if(this.$route.query.filters){
        this.filters.email = this.$route.query.email;
        this.filters.suggestion = this.$route.query.suggestion;
      }
    },
    applyFilters() {
      this.getList()
    },
    getList: function () {
      this.loaders.suggestion_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/feature-suggestion-list`, {
          headers: this.$headers,
          params: this.pagination,
        })
        .then((response) => {
          this.suggestion_list = [];
          if (response.data.status == 1) {
            // console.log(response.data.feature_suggestion_list);return;
            this.suggestion_list = response.data.feature_suggestion_list.data;
            this.total_items = response.data.feature_suggestion_list.total;
          }
        })
        .catch((error) => {
          console.log(error);

        })
        .finally(() => {
          {
            this.loaders.suggestion_list_loader = false;
          }
        });
      this.is_loading = false;
    },
    getEmailList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-suggestions-emails`,
              {headers: this.$headers})
          .then((response) => {
            if(response.data.status == 1){
              this.loading.email = false;
              this.emails = response.data.data;
            }
          }).catch((error) => {

      })
    }
    // getTitlesList: function (newVal) {
    //   this.loaders.notification_list_loader = true;
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
    //       { headers: this.$headers, params: { searched_title: newVal } }
    //     )
    //     .then((response) => {
    //       if (response.data.status == 1) {
    //         this.title_list = response.data.titles;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       // this.snack_bar.message = "Error Occured";
    //       // this.snack_bar.show;
    //     })
    //     .finally(() => {
    //       {
    //         this.loaders.notification_list_loader = false;
    //       }
    //     });
    //   this.is_loading = false;
    // },
  },
  mounted() {
    this.applyFiltersOnLoad();
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}
</style>

x
